module.exports = __webpack_public_path__ + "media/images/riders/MICHAEL_HANNAH-294f16f8f7fe9cc23e254293c78b046e.png";